import axios, { AxiosRequestConfig } from 'axios';

import { HOST_API } from 'src/config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API, timeout: 30000 });

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) =>
    Promise.reject(
      // eslint-disable-next-line no-nested-ternary
      error.response && error.response.data
        ? { ...error.response.data, status: error.response.status }
        : error?.code === 'ECONNABORTED' || error?.message.includes('Network Error')
          ? { type: 'NetworkError' }
          : new Error('Something went wrong')
    )
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
  config: 'config',
  auth: {
    login: 'users/login',
    register: 'users/signup',
  },
};
